import React from "react";
import AsyncSelect from "react-select/async";
import classes from "./ItemForm.module.scss";
import { SingleSelectOption } from "../../models/SelectOption";
import { useTranslation } from "react-i18next";
import { Lang } from "../../models/Lang";
import { externalToInternal, feedFactoryAxios } from "../../helpers";
import { InternalLocationItemModel } from "../../models/Ndtrc";
import { fetchLocationsByQuery } from "./fetchLocationsByQuery";
import { StylesConfig } from "react-select";
import { HoverDesc } from "../../components/HoverDesc";

type ColourOption = {
  type: string;
};
const _colourStyles: StylesConfig<ColourOption, true> = {
  control: (styles: any) => ({ ...styles, backgroundColor: "white" }),
  option: (styles: any, { data, isDisabled: _isDisabled, isFocused: _isFocused, isSelected: _isSelected }) => {
    return {
      ...styles,
      backgroundColor: data.type ? "#f3e3e3" : undefined,
      // color: data.type ? "white" : "inherit",
    };
  },
};

const MIN_CHAR_COUNT = 3; // Minimum number of characters to start searching

const LocationSelect = (props: {
  lang: Lang;
  filterOnUserOrganisations?: string[];
  value: InternalLocationItemModel | null;
  onChange: (loc: InternalLocationItemModel) => any;
  additionalParams?: { key: string; value: string }[];
}) => {
  const { t } = useTranslation();

  const changeLocation = (option: SingleSelectOption) => {
    feedFactoryAxios.get(`/locations/${option.value}`).then((res) => {
      const myLocation = externalToInternal(
        res.data
      ) as InternalLocationItemModel;
      props.onChange(myLocation);
    });
  };

  // TODO: Consider adding debounce
  const updateLocations = async (inputValue: string) => {
    if (inputValue.length < MIN_CHAR_COUNT) {
      return [];
    }

    return fetchLocationsByQuery(
      inputValue,
      props.lang,
      props.filterOnUserOrganisations,
      props.additionalParams
    );
  };

  return (
    <div className={classes.LocationSelect}>
      <AsyncSelect
        cacheOptions
        defaultOptions
        // TODO Remove due to upgrade to react-select v4
        // styles={colourStyles}
        loadOptions={updateLocations}
        className={classes.asyncSelect}
        noOptionsMessage={(data) =>
          data.inputValue.length < MIN_CHAR_COUNT
            ? t("locationSelect.promptMinChar", { charCount: MIN_CHAR_COUNT })
            : t("locationSelect.noOptions", { inputString: data.inputValue })
        }
        loadingMessage={() => t("locationSelect.loading")}
        // @ts-expect-error -- react-select onChange option typing mismatch
        onChange={(option: SingleSelectOption) => {
          changeLocation(option);
        }}
        onInputChange={(_inputValue) => {
          // Do nothing; but needed for async refresh
        }}
        placeholder={t("root.selectLocationItem")}
      />
      <HoverDesc description={`root.locationSelect.desc`} />
    </div>
  );
};

export default LocationSelect;
